/**
 * Enum Tính KPCĐ
 * TVDAT 12.07.2022
 */
export default {
  All: -1,
  IsLaborUnion: 1,
  NotIsLaborUnion: 0
};
